export default __webpack_public_path__ + "static/media/photo_2023-08-11_17-28-54-removebg-preview.5e20f7bc.png";